var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ve-bar',{key:_vm.componentKey,attrs:{"extend":_vm.chartExtend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }